/**
 * loading
 */

const loading = {
  namespaced: true,
  state: {
    isLoading: false,
    counter: 0,
  },
  getters: {},
  actions: {
    reset ({commit}) {
      commit('refresh');
    },
  },
  mutations: {
    refresh (state) {
      state.isLoading = false
      state.counter = 0;
      // console.log('reset', state.counter)
    },
    started (state) {
      state.isLoading = true
      state.counter++;
      // console.log('started', state.counter)
    },
    finished (state) {
      state.counter--;
      if (state.counter <= 0) {
        state.isLoading = false
        state.counter = 0;
      }
    },
  },
}

export default loading
